import { api } from '../api/http';
import { Card, PageHeader } from '../ui';

export function LoginScreen({ reason }: { reason?: string }): JSX.Element {
  return (
    <div className="tbm-login">
      <Card className="tbm-login__card">
        <PageHeader eyebrow="Twitch Bots" title="Connexion admin" />
        {reason ? <p className="tbm-error">{reason}</p> : <p className="muted">Un compte administrateur TheBlob est requis.</p>}
        <a className="tbm-btn tbm-btn--primary tbm-btn--md" data-testid="login-link" href={api.loginUrl}>
          Se connecter
        </a>
      </Card>
    </div>
  );
}

export function Splash({ children }: { children: string }): JSX.Element {
  return (
    <div className="tbm-login">
      <p className="muted">{children}</p>
    </div>
  );
}
